<!--
 @description 应用交付-首页
 @author xiehan
 @date 2018/10/16
-->
<template>
  <div class="appDelivery__content">
    <el-button type="primary" 
      @click="addDelivery"
      v-g-rac="gRac('appDelivery@add')" 
      v-text="$t('appDelivery.addDelivery')"></el-button>
    <div class="mt-base">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="0" input-width="auto">
        <el-form-item>
          <el-input v-model="searchForm.appName" :placeholder="$t('appDelivery.appName')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="search(null)" 
            v-g-rac="gRac('appDelivery@search')" 
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table-extend
      :cell-style="cellStyle"
      :cell-click="cellClick"
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      </el-table-extend>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import appDeliveryBiz from '@/logic/continuousDelivery/appDeliveryBiz'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        searchForm: {
          appName: ''
        },
        select_delivery: {},
        select_envType: {}
      }
    },
    methods: {
      async waitDelivery () {
        await this.dGetDictionaryByCode('deliverystatus')
        this.select_delivery = { ...this.dDictionary.deliverystatus }
        this.waitEnvType()
      },
      async waitEnvType () {
        await this.dGetDictionaryByCode('envType')
        this.select_envType = { ...this.dDictionary.envType }
        this.initTable()
        this.search()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'appDelivery.table',
          head: ['group', 'appName', 'version', 'clusterName', 'envType', 'creator', 'createTime', 'status'],
          requestFun: this.search,
          headOpt: {
            envType: {
              formatter: 'Dictionary',
              formatterDic: this.select_envType
            },
            status: {
              formatter: 'Dictionary',
              formatterDic: this.select_delivery
            }
          }
        })
      },
      search (data) {
        let searchObj = {}
        if (this.searchForm.appName) searchObj.appName = this.searchForm.appName
        let reqData = extend(true, data, searchObj)
        if (!data) {
          this.tResetPage()
          reqData = extend(true, { ...this.tPageInfo }, reqData)
        }
        appDeliveryBiz.getAppDeliveryByPage(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map((item) => {
              item.createTime = TimeFormat.getFormatTime(item.createTime)
            })
          }
          this.tData = data
        })
      },
      cellStyle ({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          return 'color:#0B8DE5; cursor:pointer'
        }
      },
      cellClick (row, columnKey) {
        if (columnKey === 'appName') {
          this.$router.push({ name: 'releaseOverview', query: { id: row.id } })
        }
      },
      addDelivery () {
        this.$router.push({ name: 'addAppDelivery' })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'appDelivery' && (from.name === 'addAppDelivery' || from.name === 'releaseOverview')) {
          this.waitDelivery()
        }
      }
    },
    mounted () {
      this.waitDelivery()
    }
  }
</script>

<style scoped>
</style>